(function(api) {
	
	api.GetDomList = GetDomList;
	api.GetSkolaList = GetSkolaList;
	api.GetSmjerList = GetSmjerList;
	api.PrijavaUpisi = PrijavaUpisi;
	api.GetRezervacije = GetRezervacije;
	api.GetPaviljonZaRezervacije = GetPaviljonZaRezervacije;
	api.GetKatZaRezervacije = GetKatZaRezervacije;
	
	api.ObrisiRezervaciju = ObrisiRezervaciju;
	api.RezervirajSobu = RezervirajSobu;
	api.PotvrdiRezervacijuSobe = PotvrdiRezervacijuSobe;
	
	function ObrisiRezervaciju() {
		return $.dsDirectCall({ 
			method: "sd/ObrisiRezervaciju"
		});
	}
	
	function RezervirajSobu() {
		return $.dsDirectCall({ 
			method: "sd/RezervirajSobu"
		});
	}

	function PotvrdiRezervacijuSobe(kod) {
		return $.dsDirectCall({ 
			method: "sd/PotvrdiRezervacijuSobe",
			params: [kod]
		});
	}
	
	function GetDomList (natjecaj) {
		return $.dsDirectCall({ 
			method: "sd/GetDomList", 
			params: [natjecaj]
		});
	}
	
	function GetSkolaList (natjecaj) {
		return $.dsDirectCall({ 
			method: "sd/GetSkolaList", 
			params: [natjecaj]
		});
	}
		
	function GetSmjerList (skola) {
		return $.dsDirectCall({ 
			method: "sd/GetSmjerList", 
			params: [skola]
		});
	}
	
	function PrijavaUpisi(data, errorCB, doneCB, override) {
		var dodatak = '';
		if (override)
			dodatak = '/true';
			
		return $.ajax({
	        url: kontorouter.getModulPath('prijava/spremi')+dodatak,
	        type: "POST",
	        data: data,
	        dataType: "json",
	    })
	    .error(errorCB)
	    .done(doneCB);
	}

	function GetRezervacije (paviljon, kat) {
		return $.dsDirectCall({ 
			method: "sd/GetRezervacije", 
			params: [paviljon, kat]
		});
	}	
	
	function GetPaviljonZaRezervacije() {
		return $.dsDirectCall({ 
			method: "sd/GetPaviljonZaRezervacije"
		});
	}

	function GetKatZaRezervacije(paviljon) {
		return $.dsDirectCall({ 
			method: "sd/GetKatZaRezervacije",
			params: [paviljon]
		});
	}

} (konto.sd.api = {}));